import React, {forwardRef} from 'react';
import Icon from '@/components/icons/Icon';

interface Props {
    onFormSubmit: () => void;
}

export const SingleDatePickerForm = forwardRef<HTMLInputElement, Props>(
    ({onFormSubmit}, ref) => {
        const specificID = (Math.random() + 1).toString(36).substring(7);
        return (
            <form className="form-inline" id="daterangepicker" role="form" method="POST" onSubmit={
                (e: React.FormEvent<HTMLFormElement>) => {
                    e.preventDefault();
                    onFormSubmit();
                }
            }>
                <div className='input-group date'>
                    <input
                        data-cy="reporting-range-picker-text-input"
                        autoComplete="off"
                        className="form-control"
                        type="text"
                        name="report_range_single"
                        id={`report_range_single-${specificID}`}
                        ref={ref}
                    />
                    <label className="border-left-0"
                        style={{
                            border: '1px solid #ced4da',
                            borderTopRightRadius: '0.25rem',
                            borderBottomRightRadius: '0.25rem',
                        }}
                        htmlFor={`report_range_single-${specificID}`}
                    >
                        <span>
                            <Icon name="mdi-calendar" className="ml-2 mr-2" />
                        </span>
                    </label>
                </div>
            </form>
        );
    }
);
